<div class="dialog-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="header-left">
        <svg class="ai-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="ai-gradient-credit" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                </linearGradient>
            </defs>
            <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-gradient-credit)" stroke="#2C5AA0" stroke-width="1"/>
            <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
        </svg>
        <h2 class="title">Add AI funds</h2>
    </div>
</div>
<mat-dialog-content>
    <div class="dialog-content">
        <p class="description">Enter the amount of credits you want to purchase</p>
        <mat-form-field appearance="outline" class="amount-field">
            <mat-label>Amount</mat-label>
            <span matPrefix class="currency-prefix">$&nbsp;</span>
            <input matInput type="number" [(ngModel)]="amount" min="5" max="1000" autocomplete="off">
            <mat-hint>Minimum: $5, Maximum: $1000</mat-hint>
        </mat-form-field>
        <div class="quick-amounts">
            <button mat-stroked-button (click)="setAmount(5)" [class.selected]="amount === 5">$5</button>
            <button mat-stroked-button (click)="setAmount(10)" [class.selected]="amount === 10">$10</button>
            <button mat-stroked-button (click)="setAmount(25)" [class.selected]="amount === 25">$25</button>
            <button mat-stroked-button (click)="setAmount(50)" [class.selected]="amount === 50">$50</button>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-btn">Cancel</button>
    <button mat-button (click)="onOk()" class="primary-btn" [disabled]="!amount || amount < 5 || amount > 1000">
        Purchase Credits
    </button>
</mat-dialog-actions>
